export const translations = {
  en: {
    brand: "Zakariae's portfolio",
    nav: {
      home: 'Home',
      about: 'About',
      skills: 'Skills',
      certificates: 'Certificates',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      greeting: "Hi, I'm",
      getInTouch: "Get In Touch"
    },
    about: {
      title: "About Me",
      location: "Location:",
      email: "Email:",
      phone: "Phone:",
      experience: "Experience",
      education: "Education"
    },
    skills: {
      title: "Skills & Technologies",
      categories: {
        "Frontend": "Frontend",
        "Backend": "Backend",
        "Tools & Others": "Tools & Others",
        "Databases": "Databases"
      }
    },
    certificates: {
      title: "Certificates",
      viewCertificate: "View Certificate"
    },
    projects: {
      title: "My Projects",
      allProjects: "All Projects",
      featured: "Featured",
      code: "Code"
    },
    contact: {
      title: "Get In Touch",
      description: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.",
      email: "Email",
      phone: "Phone",
      location: "Location",
      name: "Name",
      namePlaceholder: "Your Name",
      emailPlaceholder: "your.email@example.com",
      message: "Message",
      messagePlaceholder: "Your Message",
      sendMessage: "Send Message",
      thankYou: "Thank you for your message! I will get back to you soon."
    },
    footer: {
      rights: "All rights reserved."
    }
  },
  fr: {
    brand: "Portfolio de Zakariae",
    nav: {
      home: 'Accueil',
      about: 'À propos',
      skills: 'Compétences',
      certificates: 'Certificats',
      projects: 'Projets',
      contact: 'Contact'
    },
    hero: {
      greeting: "Salut, je suis",
      getInTouch: "Me Contacter"
    },
    about: {
      title: "À propos de moi",
      location: "Localisation :",
      email: "Email :",
      phone: "Téléphone :",
      experience: "Expérience",
      education: "Formation"
    },
    skills: {
      title: "Compétences & Technologies",
      categories: {
        "Frontend": "Frontend",
        "Backend": "Backend",
        "Tools & Others": "Outils & Autres",
        "Databases": "Bases de données"
      }
    },
    certificates: {
      title: "Certificats",
      viewCertificate: "Voir le certificat"
    },
    projects: {
      title: "Mes Projets",
      allProjects: "Tous les projets",
      featured: "En vedette",
      code: "Code"
    },
    contact: {
      title: "Me Contacter",
      description: "Je suis toujours ouvert à discuter de nouveaux projets, d'idées créatives ou d'opportunités pour faire partie de vos visions.",
      email: "Email",
      phone: "Téléphone",
      location: "Localisation",
      name: "Nom",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "votre.email@exemple.com",
      message: "Message",
      messagePlaceholder: "Votre message",
      sendMessage: "Envoyer le message",
      thankYou: "Merci pour votre message ! Je vous répondrai bientôt."
    },
    footer: {
      rights: "Tous droits réservés."
    }
  }
};


